import SkeletonLoader from '.';

const UserDetailsSkeleton = () => {
  return (
    <div className="flex flex-col gap-10 w-full">
      <div className="flex flex-col justify-center items-center gap-6">
        <SkeletonLoader className="h-25 w-25" variant="circle" />
        <div className="flex flex-col justify-center items-center gap-4 w-full">
          <div className="flex gap-2">
            <SkeletonLoader className="h-5 w-25" variant="rect" />
            <SkeletonLoader className="h-5 w-10" variant="rect" />
          </div>
          <div className="flex gap-2">
            <SkeletonLoader className="h-5 w-35" variant="rect" />
            <SkeletonLoader className="h-5 w-30" variant="rect" />
          </div>
        </div>
      </div>
      <SkeletonLoader className="h-5 w-25" variant="rect" />
      <div className="grid grid-cols-2 gap-8">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex flex-row gap-2">
            <SkeletonLoader className="h-6 w-6" variant="rect" />
            <div className="flex flex-col gap-2">
              <SkeletonLoader className="h-5 w-20" variant="text" />
              <SkeletonLoader className="h-5 w-35" variant="text" />
            </div>
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-6">
        <div className="flex gap-2">
          <SkeletonLoader className="h-5 w-40" variant="rect" />
          <SkeletonLoader className="h-5 w-8" variant="circle" />
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex justify-between gap-2">
            <SkeletonLoader className="h-5 w-40" variant="rect" />
            <SkeletonLoader className="h-5 w-25" variant="rect" />
          </div>
          <SkeletonLoader className="h-5 w-60" variant="rect" />
        </div>
      </div>
      <div className="flex flex-col gap-6">
        <SkeletonLoader className="h-5 w-40" variant="rect" />
        <div className="flex flex-col gap-2">
          <div className="flex flex-row justify-between gap-6">
            <SkeletonLoader className="h-15 w-full" variant="rect" />
            <SkeletonLoader className="h-15 w-full" variant="rect" />
            <SkeletonLoader className="h-15 w-full" variant="rect" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetailsSkeleton;
